import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import Tab from '../../component/tab';
import TimeTab from '../../component/time-tab';
import moSettleCompare, {
  changeType, timeTabChange,
} from './store/index';
import Left from './left';
import IncomeRight from '../../component/income-right';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import moEffect from '../../store/index';
import { exportExcelFile, newRate } from '@tool/index';

interface IProps { }
interface IState { }

const IndustryCompare = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, timeList, timeActive,
    tableTitle, tableList, desc, overview,
    leftXData, leftYData, rightXData, rightYData,
  } = moSettleCompare;
  const { yearList } = moEffect;

  const exporttable = () => {
    const head:any = [
      ['行业', '人员规模', '变化率'],
    ];
    console.log(tableList);
    const list:any = [...head, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '行业对比');
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect11" className="industry-compare_10 box-111">
      <SubTitle title="行业对比" subtitle="多行业比对" active={type}
        bg={Color.secondaryColor(0.1)} color={Color.secondary}
        tabChange={(val: string) => changeType(val)}
        contentList={['人员规模采用该行业下样本公司的员工数的50分位值。（当样本少于3个时，统计的是平均值，而不是50分位。）']} />

      {type === 'chart' ? (
        <section className="content-1015">
          {!empty ? (
            <>
              <section className="content-1030">
                <section className="left-1011">
                  <p className="line-1011"><strong>人员规模</strong></p>
                  <Left height={300} xData={leftXData} yData={leftYData} name={timeActive} />
                </section>
                <section className="right-1011">
                  <p className="line-1011"><strong>变化率(%)</strong></p>
                  <IncomeRight height={300} xData={rightXData} yData={rightYData} name={timeActive} />
                </section>
              </section>
              <section className="chart-detail_11 industry-detail_11"
                style={{
                  marginTop: '26px',
                  height: '300px',
                }}>
                {overview.map((item: any, index: number) => (
                  <section key={index} className="item">
                    <span className="circle-111"><b /></span>
                    <p className="line-111">
                      {item.map((child: any, idx: number) => (
                        <Fragment key={idx}>
                          {child.mark === 'number' ? (
                            <span className="blue-11">{child.value}</span>
                          ) : null}
                          {child.mark === 'change_ratio' ? (
                            <>
                              {child.value >= 0 ? (
                                <span className="red-11">{newRate(child.value)}</span>
                              ) : (
                                <span className="green-11">{newRate(child.value)}</span>
                              )}
                            </>
                          ) : null}
                          {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                            <span className="span-11">{child.value}</span>
                          ) : null}
                        </Fragment>
                      ))}
                    </p>
                  </section>
                ))}
              </section>
            </>
          ) : <Empty />}
        </section>
      ) : (
        <section className="content-151 content-152">
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!empty ? (
            <CommonTable titleList={tableTitle} list={tableList} />
          ) : (<Empty />)}
        </section>
      )}

      <TimeTab list={yearList} active={timeActive} onChange={timeTabChange} />
    </section>
  );
};

export default observer(IndustryCompare);
